import ColVisibilitySelector from "components/DataTable/ColVisibilitySelector";
import ItemActionsMenu from "components/DataTable/ItemActionsMenu";
import React from "react";
import Checkbox from "components/Checkbox/Checkbox";
import Button from "components/Button/Button";
import { getStatusButtonColor } from "helpers/utils";
// import moment from 'moment';

export default {
    TABLE: {
        className: "data-table-affiliates",
        initialSortKey: "name",
        initialSortOrder: "asc"
    },

    COLUMN: [
        {
            label: "Row Selector",
            key: "row-selector",
            header: ({ customTableProps }) => {
                const isSelectedAll =
                    customTableProps.selectedRows &&
                    customTableProps.selectedRows.length &&
                    customTableProps.rowsData &&
                    customTableProps.rowsData.length &&
                    customTableProps.selectedRows.length ===
                        customTableProps.rowsData.length
                        ? true
                        : false;
                return (
                    <Checkbox
                        checked={isSelectedAll}
                        onChange={() => customTableProps.doSelectAll()}
                        name="row-selector"
                    />
                );
            },
            className: "col-row-selector",
            format: ({ rowData, customTableProps }) => {
                const isSelected =
                    customTableProps.selectedRows &&
                    customTableProps.selectedRows.length &&
                    customTableProps.selectedRows.some((checkbox) => {
                        return checkbox.id === rowData.id;
                    })
                        ? true
                        : false;
                return (
                    <Checkbox
                        checked={isSelected}
                        onChange={() => customTableProps.onRowSelect({ rowData })}
                        name="row-selector"
                    />
                );
            },
            canBeHidden: false
        },
        {
            label: "Name",
            header: "NAME",
            key: "name",
            sortable: true,
            className: "name",
            format: ({ rowData, customTableProps }) => {
                return <span>{rowData["name"]}</span>;
            }
        },
        {
            label: "Agreement Type",
            header: "AGREEMENT TYPE",
            key: "agreement-type",
            sortable: true,
            canBeHidden: true,
            format: ({ rowData, customTableProps }) => {
                return <span>{rowData["agreement-type"]}</span>;
            }
        },
        // {
        //     label: "Last Action",
        //     header: "LAST ACTION",
        //     key: "last_action",
        //     sortable: true,
        //     format: ({ rowData }) => {
        //         return <span>{rowData["last_action"]}</span>;
        //     }
        // },
        // {
        //     label: "Last Action Date",
        //     header: "LAST ACTION DATE",
        //     key: "last_modified",
        //     sortable: true,
        //     format: ({ rowData }) => {
        //     return <span>{rowData['last_modified'] ? moment(rowData['last_modified']).format('MM/DD/YYYY') : ''}</span>;
        //     }
        // },
        {
            label: "Audit Status",
            header: "AUDIT STATUS",
            key: "audit_status",
            sortable: true,
            canBeHidden: true,
            format: ({ rowData }) => {
                return <span>{rowData["audit_status"]}</span>;
            }
        },
        {
            label: "Approval Status",
            header: "APPROVAL STATUS",
            key: "status",
            sortable: true,
            canBeHidden: true,
            format: ({ rowData, customTableProps }) => {
                const status = rowData.status;
                const color = getStatusButtonColor(status, ["Approved"], ["Declined"]);
                return <span><Button cursorDefault={customTableProps.cursorDefault} color={color} size="md" text={status} onClick={() => null} /></span>;
            }
        },
        {
            label: "Actions",
            key: "actions",
            format: ({ rowData, customTableProps }) => {
                const actionMenuDropDown = React.createRef();
                return (
                    <ItemActionsMenu
                        ref={actionMenuDropDown}
                        actions={(() => {
                            return [
                                {
                                    label: "Edit",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.edit(rowData);
                                    }
                                },
                                {
                                    label: "Notify",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.notify(rowData)
                                    }
                                },
                                {
                                    label: "Approve",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.approve(rowData);
                                    }
                                },
                                {
                                    label: "Decline",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.decline(rowData);
                                    }
                                },
                                {
                                    label: "Email Files",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.email(rowData);
                                    }
                                },
                                rowData.audit_status === "Audit complete" ? {
                                    label: "View Vendor Audit",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.read_vendor_audit(rowData);
                                    }
                                } : false,
                                {
                                    label: "Send Vendor Audit",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.send_vendor_audit(rowData);
                                    }
                                },
                                {
                                    label: "Send BA Agreement",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.send_ba_agreement(rowData);
                                    }
                                },
                                {
                                    label: "Send Confidentiality Agreement",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.send_confidentiality_agreement(rowData);
                                    }
                                },
                                {
                                    label: "Delete",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.delete(rowData);
                                    }
                                }
                            ];
                        })()}
                    />
                );
            },
            className: "col-actions",
            header: ({ customTableProps }) => {
                return (
                    <ColVisibilitySelector
                        colDefs={customTableProps.colDefs}
                        visibleColumnKeys={customTableProps.visibleColumnKeys}
                        onChangeVisibility={colKey =>
                            customTableProps.onChangeVisibility(colKey)
                        }
                    />
                );
            }
        }
    ]
};
